/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  // ADD_ITEM(state, item) {
  //   state.products.unshift(item)
  // },
  // SET_PRODUCTS(state, products) {
  //   state.products = products
  // },

   SET_SHOP_SETTING(state, item) {
    state.tax.taxRate = item.taxRate;
    state.tax.vatSystem = item.vatSystem;
    state.tax.inVat = item.inVat;
    state.tax.receiptHeader = item.receiptHeader;
    // console.log('@@@MUTUAL state.tax ',state.tax);


  },
  UPDATE_SHOP_SETTING(state, item) {
    state.tax.taxRate = item.taxRate;
    state.tax.vatSystem = item.vatSystem;
    state.tax.inVat = item.inVat;
    state.tax.receiptHeader = item.receiptHeader;

  },
  // REMOVE_ITEM(state, itemId) {
  //   const ItemIndex = state.products.findIndex((p) => p.id == itemId)
  //   state.products.splice(ItemIndex, 1)
  // },
}
